import * as React from 'react';
import { ColumnKebab } from '../TableColumn';

type ActionsCellProps = Pick<React.ComponentProps<typeof ColumnKebab>, 'options'> & {
  isLoading?: boolean;
};

export const ActionsCell = React.memo(({ options, isLoading }: ActionsCellProps) => (
  <ColumnKebab isLoading={isLoading} width="80px" options={options} keepDropdown />
));
